import React from 'react'
import { Button, Modal } from '@dostavkee/web-ui'

import { useLogout } from '../api/mutations/use-logout'

interface LogoutModalProps {
    onClose: () => void
}

export const LogoutModal: React.FC<LogoutModalProps> = ({ onClose }) => {
    const { logoutAsync, isPending } = useLogout()

    return (
        <Modal isOpen={true} onClose={onClose}>
            <Modal.Header>Выйти</Modal.Header>
            <Modal.Body>Вы уверены, что хотите выйти?</Modal.Body>
            <Modal.Footer>
                <Button
                    data-testid='logout-modal__cancel-button'
                    size='small'
                    variant='secondary'
                    onClick={onClose}
                >
                    Отмена
                </Button>
                <Button
                    data-testid='logout-modal__submit-button'
                    isLoading={isPending}
                    size='small'
                    variant='error'
                    onClick={() => logoutAsync()}
                >
                    Выйти
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
